// extracted by mini-css-extract-plugin
module.exports = {"titleTour":"tour_titleTour__2zggf","tour":"tour_tour__M3YUA"};